module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"birth-date":"Data de nascimento"},"en-US":{"birth-date":"Founding date"}}')
  delete Component.options._Ctor
}
